<template>
    <v-app>
        <v-container>
            <v-row justify="center" align="center" cols="2" class="mt-3">
                <v-col cols="12">
                    <h1 class="blue-grey--text text--darken-3"> Hi, {{ this.getUser.given_name }}!</h1>
                </v-col>
            </v-row>
            <v-row justify="center" align="center">
                <v-col>
                    <v-card elevation="5" class="mb-3 pl-4 pr-4 pb-4">
                        <v-card-title >
                            <v-row align="center" justify="center">
                                <v-col cols="7">
                                    My Requests
                                </v-col>
                                <v-col cols="5">
                                    <v-text-field
                                            v-model="searchMyRequests"
                                            append-icon="mdi-magnify"
                                            label="Search My Requests"
                                            single-line
                                            hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table
                                    :headers="userRequestsHeaders"
                                    :items="userRequests"
                                    :items-per-page="5"
                                    class="elevation-1"
                                    sort-by="createdAt"
                                    sort-desc
                                    :search="searchMyRequests"
                                    no-data-text="No requests have been submitted."
                                    :loading=loading
                            >
                                <template v-slot:item.createdAt="{ item }">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                    small
                                                    color="red"
                                                    class="mr-2"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    v-if="item.urgent">
                                                mdi-alert-circle-outline</v-icon>
                                        </template>
                                        <span>Urgent</span>
                                    </v-tooltip>
                                    {{ new Date(item.createdAt).toLocaleDateString()}}
                                </template>
                                <template v-slot:item.dueDate="{ item }">
                                    {{ new Date(item.dueDate+"T12:00:00").toLocaleDateString()}}
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-btn x-small class="blue-grey lighten-5" :to="requestURL(item)">View</v-btn>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row justify="center" align="center">
                <v-col>
                    <v-card elevation="5" class="mb-5 pl-4 pr-4 pb-4">
                        <v-card-title>
                            <v-row align="center" justify="center">
                                <v-col cols="7">
                                    All Requests from {{ this.getOrganization.name }}
                                </v-col>
                                <v-col cols="5">
                                    <v-text-field
                                            v-model="searchAllRequests"
                                            append-icon="mdi-magnify"
                                            label="Search All Requests"
                                            single-line
                                            hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table
                                    :headers="allRequestHeaders"
                                    :items="allRequests"
                                    :items-per-page="5"
                                    class="elevation-1"
                                    sort-by="createdAt"
                                    sort-desc
                                    :search="searchAllRequests"
                                    no-data-text="No requests have been submitted."
                                    :loading=loading
                            >
                                <template v-slot:item.createdAt="{ item }">
                                    <v-icon small color="red" class="mr-2" v-if="item.urgent">mdi-alert-circle-outline</v-icon>{{ new Date(item.createdAt).toLocaleDateString()}}
                                </template>
                                <template v-slot:item.dueDate="{ item }">
                                    {{ new Date(item.dueDate+"T12:00:00").toLocaleDateString()}}
                                </template>
                                <template v-slot:item.user="{ item }">
                                    <span>{{ `${item.user.firstName} ${item.user.lastName.substr(0, 1)}.` }}</span>
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-btn x-small class="blue-grey lighten-5" :to="requestURL(item)">View</v-btn>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "Dashboard",
        computed: {
            ...mapGetters(['getUser', 'getOrganization', 'allRequests', 'userRequests']),
        },
        methods: {
            ...mapActions(['fetchUser', 'fetchOrganization', 'fetchRequests']),
            requestURL(request) {
                return `/view?id=${request.id}`
            },
        },
        async created() {
            await this.fetchUser();
            await this.fetchOrganization();
            await this.fetchRequests();
            this.loading = false;
        },
        mounted() {
        },
        data: () => ({
            loading: true,
            searchMyRequests: '',
            searchAllRequests: '',
            userRequestsHeaders: [
                { text: 'Submitted', align: 'start', value: 'createdAt' },
                { text: 'Due', value: 'dueDate' },
                { text: 'Ticket ID', align: 'start', value: 'ticketID' },
                { text: 'Request Title', value: 'title' },
                { text: 'Status', value: 'status' },
                { text: 'Action', value: 'action', sortable: false, align: 'center' },
            ],
            allRequestHeaders: [
                { text: 'Submitted', align: 'start', value: 'createdAt' },
                { text: 'Due', value: 'dueDate' },
                { text: 'Ticket ID', align: 'start', value: 'ticketID' },
                { text: 'Submitted By', align: 'start', value: 'user' },
                { text: 'Request Title', value: 'title' },
                { text: 'Status', value: 'status' },
                { text: 'Action', value: 'action', sortable: false, align: 'center' },
            ],
        })
    }
</script>

<style >

</style>